import {
  PlanAccountImport,
  PlanAccountClassification,
  PlanAccountDestination,
  PlanAccountHierarchy,
  PlanAccountType,
} from './PlanAccounts.types';

export const planAccountBodyWorkMock: PlanAccountImport[] = [
  {
    code: '1000',
    description: 'Receitas',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Revenue,
    subPlanAccounts: [
      {
        code: '1000.0001',
        description: 'Seguradora',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0002',
        description: 'Particular',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0003',
        description: 'Franquia',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0004',
        description: 'Empréstimos',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0005',
        description: 'Venda de Sucatas',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0006',
        description: 'Transferência de Entrada',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0007',
        description: 'Ajuste de Saldo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0008',
        description: 'Estorno',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
    ],
  },
  {
    code: '2000',
    description: 'Despesas',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.withoutClassification,
  },
  {
    code: '2100',
    description: 'Despesas Administrativas',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.Fixed,
    subPlanAccounts: [
      {
        code: '2100.0001',
        description: 'Aluguel',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0002',
        description: 'Energia',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0003',
        description: 'Água e Saneamento',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0004',
        description: 'Telefonia',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0005',
        description: 'Contabilidade',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0006',
        description: 'Sistema de Gestão',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0007',
        description: 'Correios',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0008',
        description: 'Informática',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0009',
        description: 'Seguro',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0010',
        description: 'Material de Escritório',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0011',
        description: 'Tarifas Bancárias',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0012',
        description: 'Aluguel de Maquineta',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0013',
        description: 'Empréstimos Bancários',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0014',
        description: 'Parcelamento de Impostos',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0015',
        description: 'Material de Limpeza',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
    ],
  },
  {
    code: '2200',
    description: 'Despesas Funcionários',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.withoutClassification,
    subPlanAccounts: [
      {
        code: '2200.0001',
        description: 'FOLHA DE PAGTO. - DESM/MONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0002',
        description: 'ADIANTAMENTO SALARIAL - DESM/MONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0003',
        description: '13º SALARIO - DESM/MONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0004',
        description: 'PLANO SAÚDE - DESM/MONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0005',
        description: 'RESTAURANTE/LANCHE - DESM/MONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0006',
        description: 'VALE TRANSPORTE - DESM/MONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0007',
        description: 'CONTRIBUICAO SINDICAL - DESM/MONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0008',
        description: 'I.N.S.S. - DESM/MONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0009',
        description: 'F.G.T.S. - DESM/MONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0010',
        description: 'FERIAS - DESM/MONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0011',
        description: 'COMISSÃO DESM/MONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0012',
        description: 'RESCISÃO DESMONTAGEM',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
    ],
  },
  {
    code: '2300',
    description: 'Despesas Variavéis',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.Variable,
    subPlanAccounts: [
      {
        code: '2300.0001',
        description: 'Fornecedores de Peças',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0002',
        description: 'Fornecedores de Insumos',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0003',
        description: 'Juros Bancários',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0004',
        description: 'Antecipação de Cartão',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0005',
        description: 'Fretes e Carretos',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0006',
        description: 'Manutenção de Equipamentos',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0007',
        description: 'Reforma e Melhoria Predial',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
    ],
  },
  {
    code: '2400',
    description: 'Impostos/Contribuições',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.Fixed,
    subPlanAccounts: [
      {
        code: '2400.0001',
        description: 'Simples Nacional',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2400.0002',
        description: 'ISS',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2400.0003',
        description: 'IPTU',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2400.0004',
        description: 'ICMS',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
    ],
  },
  {
    code: '2500',
    description: 'Pro Labore',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.Fixed,
    subPlanAccounts: [
      {
        code: '2500.0001',
        description: 'Retirada mensal',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2500.0002',
        description: 'Combustível Proprietário',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2500.0003',
        description: 'Alimentação Proprietário',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2500.0004',
        description: 'Outras Retiradas Proprietário',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
    ],
  },
];
